import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

type ViewerInvitePayload = {
    projectId: string;
    emails: string[];
    languages: number[];
    keys: number[];
    comment?: string;
};

const viewerApi = createApi({
    reducerPath: 'viewer',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        viewerInvite: builder.mutation<void, ViewerInvitePayload>({
            query: (payload) => ({
                method: 'POST',
                url: '/viewer/invite',
                body: payload,
            }),
        }),
    }),
});

export default viewerApi;

export const { useViewerInviteMutation } = viewerApi;
